"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const NewGiveawayForm_1 = __importDefault(require("./NewGiveawayForm"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const styles_css_1 = __importDefault(require("./styles.css"));
const time_1 = require("../../../utility/time");
const icon_1 = __importDefault(require("../../../client/icon"));
const c = {
    container: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter30}`,
    header: ` ${layout_css_1.default.flexStartItems} ${layout_css_1.default.fullWidth} ${layout_css_1.default.gutter15} ${layout_css_1.default.paddingBottom10} ${util_css_1.default.borderBottom}`,
    list: `${styles_css_1.default.list}`,
    row: `${layout_css_1.default.padding15} ${styles_css_1.default.row}`,
    tableHeader: `${layout_css_1.default.padding15} ${typography_css_1.default.bold} ${util_css_1.default.borderBottom} ${styles_css_1.default.row} ${styles_css_1.default.tableHeader}`,
    actions: `${layout_css_1.default.marginLeftAuto} ${layout_css_1.default.flex} ${layout_css_1.default.gutter15}`,
    min125: `${styles_css_1.default.min125}`,
};
const Giveaways = ({ giveaways }) => {
    const [showNewForm, setShowNewForm] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: c.container },
        react_1.default.createElement("div", { className: c.header },
            react_1.default.createElement("h1", { className: `${typography_css_1.default.h1} ${typography_css_1.default.fontWeightNormal}` }, "Giveaways"),
            react_1.default.createElement(base_1.default, { disabled: showNewForm, onClick: () => setShowNewForm(true), size: "md" }, "New")),
        showNewForm && react_1.default.createElement(NewGiveawayForm_1.default, { setShowForm: setShowNewForm }),
        giveaways.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("ul", { className: c.list },
                react_1.default.createElement("div", { className: c.tableHeader },
                    react_1.default.createElement("span", null, "Title"),
                    react_1.default.createElement("div", { className: c.actions },
                        react_1.default.createElement("span", { className: `${c.min125} ${typography_css_1.default.textCenter}` }, "Start date"),
                        react_1.default.createElement("span", { className: `${c.min125} ${typography_css_1.default.textCenter}` }, "End date"),
                        react_1.default.createElement("span", { className: `${c.min125} ${typography_css_1.default.textCenter}` }, "Status"),
                        react_1.default.createElement("span", null, "Link"))),
                giveaways.map(({ end_date, has_content, id, path, start_date, status, title, }) => {
                    const started = status === 'completed' || status === 'in_progress';
                    const ended = status === 'completed';
                    const startDate = start_date && !started
                        ? (0, time_1.timestampToRelativeTime)(start_date)
                        : '-';
                    const endDate = end_date && !ended
                        ? (0, time_1.timestampToRelativeTimeRemaining)({ timestamp: end_date, minCutoff: 'day' })
                        : '-';
                    return (react_1.default.createElement("li", { key: id, className: c.row },
                        react_1.default.createElement("a", { href: `giveaways/${id}/edit` }, title),
                        react_1.default.createElement("div", { className: c.actions },
                            react_1.default.createElement("span", { className: `${c.min125} ${typography_css_1.default.textCenter}` }, started ? 'Started!' : startDate),
                            react_1.default.createElement("span", { className: `${c.min125} ${typography_css_1.default.textCenter}` }, ended ? 'Ended!' : endDate),
                            react_1.default.createElement("span", { className: `${c.min125} ${typography_css_1.default.textCenter}` }, status),
                            react_1.default.createElement("a", { className: has_content ? '' : `${typography_css_1.default.linkDisabled} ${typography_css_1.default.iconDisabled} `, href: path, rel: "noreferrer", target: "_blank" },
                                react_1.default.createElement("span", null, "View"),
                                react_1.default.createElement(icon_1.default, { name: "external-link" })))));
                }))))));
};
exports.default = Giveaways;
